module.exports = __webpack_public_path__ + "static/img/16.07a66f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/eng/16.png
// module id = UY3G
// module chunks = 0